import React, { Component } from 'react';
import { Container, Col } from 'react-bootstrap';
import './aboutus.scss';

// Images
import GardeningTools from '../../assets/img/services/tree_20.jpg'

// Components
import { Section } from '../shared/section/section';
import { Footer } from '../shared/footer/footer';
import ViewGalleryContainer from '../shared/view-gallery-container/view-gallery-container';

class AboutUs extends Component {
  render() {
    return (
      <Container fluid={true}>
          <Col className="no-padding">
            <div className="image-header" style={ 
              { 
                backgroundImage: `url(${GardeningTools})`,
                backgroundSize: '100% 100%',
              }} />
          </Col>
        <Section title="About Us" 
          content="ABC Tree Service is a family business founded by Gil and Erasto Velazquez in 1997 located in Gilroy CA.
          Gil and Erasto love what they do, take a lot of pride in their work. Their commitment is see happy customers.
          With their 30 years of experience, cordial attitude, great references and commitment to get things done you can be confident that they will do an excellent job for you."/>
        <ViewGalleryContainer />
        <Footer />
      </Container>
    );
  }
}

export default AboutUs;
